import React, { useState, useEffect } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

import '../../styles/reviews.scss';
import { Alert, Avatar, Button, Chip, FormControl, FormLabel, Option, Select, Skeleton, Snackbar, Stack, Textarea, Typography } from '@mui/joy';
import { AutoAwesome, Report, Star } from '@mui/icons-material';
import ReactMarkdown from 'react-markdown';
import Rating from "@mui/material/Rating"
import { useAuth } from '../../context/authContext';

const networking = require('../../Networking/API');
const wingmanAPI = require('../../Networking/Wingman/wingmanAPI');
const replykitNetworking = require('../../Networking/Reply Kit/ReplykitAPI');
const helper = require('../../Helpers/helpers');

function ReplyPopUpComponent({ subscription, app, review, handler }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(false);
    const [wmloading, setwmLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [displayedText, setDisplayedText] = useState("");
    const [wingmanSuggestions, setWingmanSuggestions] = useState("");
    const [wingmanTone, setWingmanTone] = useState("");
    const [wingmanClassification, setWingmanClassification] = useState<number>(1);
    const [defaultResponse, setDefaultResponse] = useState("");
    const [predefinedReplies, setPredefinedReplies] = useState<Array<any>>([]);

    useEffect(() => {
        if (wingmanSuggestions.length !== 0) {
            let i = 0;
            const interval = setInterval(() => {
                setDisplayedText((prev) => wingmanSuggestions.slice(0, i + 1)); // ✅ Fix: Use `slice()`
                i++;
                if (i >= wingmanSuggestions.length) clearInterval(interval); // ✅ Fix: Stop correctly
            }, 5);

            return () => clearInterval(interval);
        }
    }, [wingmanSuggestions]);

    useEffect(() => {
        if (subscription.plan === 'AAA' || subscription.plan === 'U') {
            getRepliesOnKit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRepliesOnKit = () => {
        setLoading(true);
        replykitNetworking.getRepliesOnKit(app.id, token).then((replies: any) => {
            setLoading(false);
            setPredefinedReplies(replies);

        }).catch((error: Error) => {
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    };

    const sendReply = (event: any) => {
        if (app.playstore_connect === false && review.store === 'playstore') {
            // 
            // For AA plan, we don't send the reply directly, but guide the user to do it manually.
            //
            // Play Store URL:
            // https://play.google.com/console/u/0/developers/4976316348021213113/app/4976316348021213113/reviews
            //
            // App Store URL:
            //
            // https://appstoreconnect.apple.com/apps/6478173852/distribution/ratings/ios

            const storeUrl = review.store === 'playstore' ?
                `https://play.google.com/console/u/0/developers/${app.androidpackageid}/app/${app.androidpackageid}/user-feedback/reviews` :
                `https://appstoreconnect.apple.com/apps/${app.appleappid}/distribution/ratings/ios`;
            window.open(storeUrl, '_blank');

            return;
        }

        if (app.appstore_connect === false && review.store === 'appstore') {
            // 
            // For AA plan, we don't send the reply directly, but guide the user to do it manually.
            //
            // Play Store URL:
            // https://play.google.com/console/u/0/developers/4976316348021213113/app/4976316348021213113/reviews
            //
            // App Store URL:
            //
            // https://appstoreconnect.apple.com/apps/6478173852/distribution/ratings/ios

            const storeUrl = review.store === 'playstore' ?
                `https://play.google.com/console/u/0/developers/${app.androidpackageid}/app/${app.androidpackageid}/user-feedback/reviews` :
                `https://appstoreconnect.apple.com/apps/${app.appleappid}/distribution/ratings/ios`;
            window.open(storeUrl, '_blank');

            return;
        }

        event.preventDefault();
        setLoading(true);

        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        if (review.store === 'playstore') {
            networking.sendPlaystoreReply(app.id, review.store_id, formJson.reply).then((success: boolean) => {
                setLoading(false);

                handler(true);
            }).catch((error: Error) => {
                setError(error.message);
                setShowError(true);
                setLoading(false);
            });
        } else {
            networking.sendAppstoreReply(app.id, review.store_id, formJson.reply).then((success: boolean) => {
                setLoading(false);
                handler(true);
            }).catch((error: Error) => {
                setError(error.message);
                setShowError(true);
                setLoading(false);
            });
        }
    };

    const getWingmanSuggestions = () => {
        setwmLoading(true);
        wingmanAPI.getResponseForReview(app, review.content).then((r: any) => {
            setwmLoading(false);
            setWingmanSuggestions(r.insights.response);
            setWingmanClassification(r.insights.responsability);
            setWingmanTone(r.insights.tone);
        }).catch((error: Error) => {
            setError(error.message);
            setShowError(true);
            setwmLoading(false);
        });
    };

    const getNewResponse = () => {
        getWingmanSuggestions()
    }

    const applyResponse = () => {
        setDefaultResponse(wingmanSuggestions);
    }

    const applyPredefinedResponse = (response: string) => {
        setDefaultResponse(response);
        setWingmanSuggestions("");
        setDisplayedText("");
    }

    return (
        <div>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    <div className='row mt-2 mb-4'>
                        <div className='col-auto'>
                            <Avatar>
                                {helper.getInitials(review.author)}
                            </Avatar>
                        </div>
                        <div className='col'>
                            <Alert>
                                <Stack
                                    direction='column'
                                    spacing={1}>
                                    <div>
                                        <Rating
                                            value={Number(review.rating)}
                                            readOnly size="small"
                                            emptyIcon={<Star
                                                style={{ opacity: 0.55 }}
                                                fontSize="inherit" />} />
                                    </div>
                                    <div>
                                        {review.content}
                                    </div>
                                </Stack>
                            </Alert>
                        </div>
                    </div>
                    <div className='form-group'>
                        <form
                            onSubmit={(event) => {
                                sendReply(event)
                            }}>
                            {subscription.plan === 'AA' &&
                                <Alert
                                    color="primary"
                                    endDecorator={
                                        <Button
                                            size="sm"
                                            variant="soft"
                                            color="primary"
                                            onClick={() => handler(false)}>
                                            Upgrade Plan
                                        </Button>
                                    }>
                                    <Typography level="body-sm">
                                        Reply Kit and Wingman AI reply generation are available on the
                                        Growth and Premium plans.
                                    </Typography>
                                </Alert>
                            }
                            {(subscription.plan === 'AAA' || subscription.plan === 'U') &&
                                <>
                                    {(review.store === 'playstore' && app.playstore_connect === false) ?
                                        <Alert color="warning">
                                            Connect your app to Google Play Console to be able to send replies directly from Apppinion.
                                        </Alert>
                                        :
                                        (review.store === 'applestore' && app.appstore_connect === false) ?
                                            <Alert color="warning">
                                                Connect your app to App Store Connect to be able to send replies directly from Apppinion.
                                            </Alert>
                                            :
                                            <>

                                                {predefinedReplies.length === 0 ?
                                                    <Alert color="warning">
                                                        You have no Reply Kit templates yet.
                                                        Please create some in the App Settings to use predefined replies.
                                                    </Alert>
                                                    :
                                                    <FormControl>
                                                        <FormLabel
                                                            sx={{ fontSize: '12px', marginBottom: 1 }}>
                                                            Use my Reply Kit
                                                        </FormLabel>
                                                        <Select
                                                            name='countryCode'
                                                            color="neutral"
                                                            size="lg"
                                                            variant="outlined"
                                                            sx={{ fontSize: '14px' }}
                                                            onChange={(_, value: any) => applyPredefinedResponse(value)}>
                                                            {
                                                                predefinedReplies.map((reply: any) => (
                                                                    <Option
                                                                        key={reply.id}
                                                                        value={reply.body}
                                                                        sx={{ fontSize: '14px', maxWidth: '700px', background: '#ffffff' }}>
                                                                        {reply.category}
                                                                    </Option>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                }

                                                <Typography
                                                    level="body-xs"
                                                    sx={{ mt: 2, mb: 1 }}>
                                                    Or use Wingman to generate a reply:
                                                </Typography>

                                                < Alert
                                                    className="mt-2 mb-2"
                                                    size="lg"
                                                    variant="soft"
                                                    color="primary"
                                                >
                                                    <>
                                                        <div>
                                                            <div className='row gx-2 mb-2'>
                                                                <div className='col-auto'>
                                                                    <AutoAwesome
                                                                        sx={{
                                                                            width: '16px'
                                                                        }} />
                                                                </div>
                                                                <div className='col-auto my-auto'>
                                                                    <Typography
                                                                        level="title-sm">
                                                                        {'Hi 👋, I’m your Wingman. \
                                                Need help with a reply?'}
                                                                    </Typography>
                                                                </div>
                                                                <div className='col-auto'>
                                                                    {wingmanSuggestions.length !== 0 &&
                                                                        <Chip
                                                                            variant="solid"
                                                                            color={wingmanClassification > 4 ? "danger" : wingmanClassification > 3 ? "warning" : "success"}
                                                                            size="sm"
                                                                        >
                                                                            {wingmanClassification > 4 ? "Must answer" : wingmanClassification > 3 ? "Should answer" : "Not urgent"}
                                                                        </Chip>
                                                                    }
                                                                </div>
                                                                <div className='col-auto'>
                                                                    {wingmanSuggestions.length !== 0 &&
                                                                        <Chip
                                                                            variant="solid"
                                                                            color="neutral"
                                                                            size="sm"
                                                                        >
                                                                            {wingmanTone}
                                                                        </Chip>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {wmloading ?
                                                                <Typography
                                                                    level='body-xs'>
                                                                    <Skeleton>
                                                                        The general sentiment across the reviews is predominantly negative, with users expressing acute frustration with various technical difficulties.
                                                                        A major issue highlighted is the inability to log in, particularly after app updates, and persistent problems with the app's user interface, especially on iPads.
                                                                        There are very few positive mentions, which indicate occasional satisfaction with app updates and simplicity.
                                                                        What do you like to know?
                                                                    </Skeleton>
                                                                </Typography>
                                                                :
                                                                <>
                                                                    <Typography
                                                                        level="body-sm"
                                                                        className='ms-4 markdown-content'>
                                                                        {wingmanSuggestions &&
                                                                            <ReactMarkdown>
                                                                                {displayedText}
                                                                            </ReactMarkdown>
                                                                        }
                                                                    </Typography>

                                                                    {displayedText === wingmanSuggestions &&
                                                                        <>
                                                                            <div className='row gx-2 mt-2 my-auto'>
                                                                                <div className='col-auto my-auto'>
                                                                                    <Chip
                                                                                        variant="outlined"
                                                                                        color="neutral"
                                                                                        size="lg"
                                                                                        startDecorator={<AutoAwesome
                                                                                            sx={{
                                                                                                width: '14px'
                                                                                            }} />}
                                                                                        sx={{
                                                                                            marginLeft: 2,
                                                                                            fontSize: "14px"
                                                                                        }}
                                                                                        onClick={() => (getNewResponse())}>
                                                                                        Generate new reply
                                                                                    </Chip>
                                                                                </div>
                                                                                {wingmanSuggestions.length !== 0 &&
                                                                                    <div className='col my-auto'>
                                                                                        <Chip
                                                                                            variant="outlined"
                                                                                            color="primary"
                                                                                            size="lg"
                                                                                            sx={{
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                            onClick={() => (applyResponse())}>
                                                                                            Use this reply.
                                                                                        </Chip>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </>
                                                </Alert>


                                                <FormControl
                                                    sx={{
                                                        marginTop: 2
                                                    }}>
                                                    <FormLabel
                                                        sx={{ fontSize: '12px', marginBottom: 1 }}>
                                                        Reply text
                                                    </FormLabel>
                                                    <Textarea
                                                        name="reply"
                                                        defaultValue={defaultResponse}
                                                        required
                                                        placeholder='Type your reply template here...'
                                                        size='md'
                                                        minRows={4}
                                                        sx={{
                                                            fontSize: '14px'
                                                        }} />
                                                </FormControl>
                                            </>
                                    }
                                </>
                            }
                            <Button
                                type='submit'
                                sx={{ mt: 6 /* margin top */ }}>
                                {
                                    review.store === 'playstore' ?
                                        app.playstore_connect === false ?
                                            "Reply via Play Store"
                                            :
                                            "Send Reply"
                                        :
                                        app.appstore_connect === false ?
                                            "Reply via App Store Connect"
                                            :
                                            "Send Reply"
                                }
                            </Button>
                        </form>
                    </div>
                </>
            }
        </div >
    )
}

export default ReplyPopUpComponent;